import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import api from '../../services/api';

import Header from '../../components/Header';
import Button from '../../components/Button';
import Footer from '../../components/Footer';

import appleBadge from '../../assets/landingPage/apple-badge.png';
import googlePlayBadge from '../../assets/landingPage/googleplay-badge.png';

import { Container, Informations, DownloadApp, StoreLinks } from './styles';

// O app so esta publicado na loja brasileira: o link sem o pais da 404.
const APP_STORE_URL = 'https://apps.apple.com/br/app/worsheep/id6444164597';
const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.projectyapp';

const Congratulations = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    sendPurchaseToDataLayer();
  }, []);

  const sendPurchaseToDataLayer = async () => {
    const planID = localStorage.getItem('YogaCO@ChoosedPlan');
    if (!planID) return;

    // Evita contar a mesma compra de novo se a pessoa recarregar a pagina.
    if (sessionStorage.getItem('YogaCO@PurchaseTracked') === planID) return;

    try {
      const response = await api.get('/plan-types?isVisible=true');
      const plan = response.data.find((item) => item.id === planID);
      if (!plan) return;

      // No boleto a pessoa chega aqui logo depois de gerar o boleto, antes
      // de pagar. O payment_method permite separar isso no GTM.
      const paymentMethod = new URLSearchParams(location.search).get('pagamento');

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'purchase_completed',
        plan_name: plan.name,
        plan_value: Number(plan.price),
        payment_method: paymentMethod || 'desconhecido',
      });

      sessionStorage.setItem('YogaCO@PurchaseTracked', planID);
    } catch (error) {}
  };

  return (
    <Container>
      <Header />
      <div>
        <Informations>
          <div>
            <h1>Parabéns</h1>
            <p>
              Nós somos muito gratos por você estar aqui. É um prazer imenso ter
              você conosco
            </p>
            <span>A sua plataforma</span>
            <span>Worsheep</span>
          </div>

          <DownloadApp>
            <h2>Agora é só afinar</h2>
            <p>
              Baixe o app e chegue no próximo ensaio sabendo a sua parte.
            </p>
            <StoreLinks>
              <a href={APP_STORE_URL} target="_blank" rel="noreferrer">
                <img src={appleBadge} alt="Baixar na App Store" />
              </a>
              <a href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer">
                <img src={googlePlayBadge} alt="Disponível no Google Play" />
              </a>
            </StoreLinks>
          </DownloadApp>

          <Button onClick={() => history.push('/')}>Vamos começar!</Button>
        </Informations>
      </div>
      <Footer />
    </Container>
  );
};

export default Congratulations;
